/* eslint-disable @typescript-eslint/no-explicit-any */
interface UtilityActionI {
  type:
    | "showToast"
    | "hideToast"
    | "LOGIN_STATUS"
    | "logout"
    | "errorFound"
    | "websocketqeuedtask"
    | "websocketnotification";
  state: any;
}
type errorType = "fullPage" | "modulePage" | "";
interface StateI {
  showToast: ObjectI;
  showID: number;
  LOGIN_STATUS?: {
    [name: string]: any;
    state: "LOGIN" | "LOGOUT";
  };
  errorFound: {
    location: string | null;
    showError: boolean;
    errorType?: errorType;
    message?: string | null;
  };
  websocketqeuedtask: {
    sync: number;
  };
  websocketnotification: {
    sync: number;
  };
}

interface ObjectI {
  [name: string]: any;
}

export const utility = (
  state: StateI = {
    showToast: {},
    showID: 1,
    errorFound: {
      location: null,
      showError: false,
      errorType: "",
      message: null,
    },
    websocketqeuedtask: {
      sync: 0,
    },
    websocketnotification: {
      sync: 0,
    },
  },
  action: UtilityActionI
): StateI => {
  switch (action.type) {
    case "showToast": {
      const nextShowID = (state as any).showID ?? 1;
      const nextShowToast = { ...((state as any).showToast ?? {}), [nextShowID]: action.state };
      return { ...state, showToast: nextShowToast, showID: nextShowID + 1 };
    }
    case "hideToast": {
      const currentShowToast = (state as any).showToast ?? {};
      const nextShowToast = { ...currentShowToast };
      if (action.state?.id !== undefined) {
        delete nextShowToast[action.state.id];
      }
      return { ...state, showToast: nextShowToast };
    }
    case "logout":
      return {
        showToast: {},
        showID: 1,
        errorFound: {
          showError: false,
          location: null,
        },
        websocketqeuedtask: {
          sync: 0,
        },
        websocketnotification: {
          sync: 0,
        },
      } as any;
    case "LOGIN_STATUS":
      return {
        ...state,
        LOGIN_STATUS: {
          ...action.state,
        },
      };
    case "errorFound":
      return {
        ...state,
        errorFound: action.state,
      };
    case "websocketqeuedtask":
      return {
        ...state,
        websocketqeuedtask: action.state,
      };
    case "websocketnotification":
      return {
        ...state,
        websocketnotification: action.state,
      };
    default:
      return state;
  }
};
